var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _path6, _path7, _path8, _path9, _path10, _rect, _polygon2, _polygon3, _polygon4, _path11, _path12, _polygon5, _polygon6, _path13, _line, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect2, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFurnace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st1 {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.1,277.2c0-5-4-9.1-9.1-9.1,5,0,9.1,4.1,9.1,9.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387.3,277.2c0-5-4-9.1-9.1-9.1,5,0,9.1,4.1,9.1,9.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.2,495.3s0,0-.1.1v15.6c0,1.6.4,3.2,1.2,4.5h.1c-.8-1.3-1.2-2.9-1.2-4.5v-15.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466,281.8s0,0,0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.1,497.3h10.3s0,0,0,0h-10.2c-4.3,0-7.8-2.9-8.8-6.8h-16.3s16.2,0,16.2,0c1,3.9,4.5,6.8,8.8,6.8Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "470.6 277.2 470.6 277.2 470.6 277.2 470.6 277.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M504.7,510.9c0,2.5-2.1,4.5-4.5,4.5h-243.9c-2.5,0-4.5-2.1-4.5-4.5h0c0,2.6,2.1,4.6,4.5,4.6h243.9c2.5,0,4.5-2.1,4.5-4.5h0v-214.3h0v214.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.7,122.2c-1.4,0-2.6,1.6-2.6,3.6,0-1.9,1.2-3.6,2.6-3.6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.1,482.2h0c0,2,1.2,3.7,2.6,3.7h0c-1.4,0-2.6-1.7-2.6-3.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.3,482.3h0c0,0,0,0,0,0,0,1.2-.3,2.5-.7,3.6h0c.4-1.1.7-2.2.7-3.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.2,89.2c0-.7,0-1.5.2-2.1h0c-.1.7-.2,1.4-.2,2.1v15.7c-1.6-1.2-3.6-2-5.7-2h-10.3c-5,0-9.1,4-9.1,9.1v205.1h0c0,0,0,0,0,0h-15.9c0,.1,16,.1,16,.1V112c0-5,4-9.1,9.1-9.1h10.3c2.2,0,4.2.7,5.7,2v-15.7Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 183.3,
    y: 321.7,
    width: 38.7,
    height: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "461.5 277.2 461.5 277.2 461.5 277.2 461.5 277.2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "373.7 277.2 373.7 277.2 373.7 277.2 373.7 277.2"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "295 277.2 295 277.2 295 277.2 295 277.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.5,277.2c0-5-4-9.1-9.1-9.1,5,0,9.1,4.1,9.1,9.1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.4,281.8s0,0,0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "285.9 277.2 285.9 277.2 285.9 277.2 285.9 277.2"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "382.8 277.2 382.8 277.2 382.8 277.2 382.8 277.2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.2,281.8s0,0,0,0,0,0,0,0c0,0,0,0,0,0s0,0,0,0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 222,
    y1: 317.1,
    x2: 222,
    y2: 317.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222,111.9c0-5.1,4.1-9.1,9.1-9.1h10.3c2.1,0,4.1.7,5.7,2v-15.7c0-.7,0-1.3.2-2l-37.8,9.9c-2,.5-3.4,2.3-3.4,4.4v215.7h15.9V111.9Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247,495.4c-1.6,1.2-3.5,1.9-5.6,1.9h0s0,0,0,0h-10.3c-4.3,0-7.8-2.9-8.8-6.8h-16.2v20.5c0,2.5,2.1,4.5,4.5,4.5h37.6c-.8-1.3-1.2-2.9-1.2-4.5v-15.6Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M251.7,292h253.1v-29.6h-253.1v29.6ZM466,268.1c5.1,0,9.1,4.1,9.1,9.1s-4,9.1-9.1,9.1-9.1-4.1-9.1-9.1,4.1-9.1,9.1-9.1ZM378.2,268.1c5.1,0,9.1,4.1,9.1,9.1s-4,9.1-9.1,9.1-9.1-4.1-9.1-9.1,4.1-9.1,9.1-9.1ZM290.4,268.1c5.1,0,9.1,4.1,9.1,9.1s-4,9.1-9.1,9.1-9.1-4.1-9.1-9.1,4.1-9.1,9.1-9.1Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.3,515.5h243.9c2.5,0,4.5-2.1,4.5-4.5v-214.2h-253v214.2c0,2.5,2.1,4.5,4.5,4.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M182.6,485.8h39.4v-164.1h-38.7v160.5h0c0,1.4-.3,2.5-.7,3.6Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.2,122.2h-72.5c-1.4,0-2.6,1.7-2.6,3.6v356.5c0,2,1.2,3.6,2.6,3.6h72.5c1.4,0,2.6-1.6,2.6-3.6V125.8c0-1.9-1.2-3.6-2.6-3.6Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M504.7,89.1c0-2.5-2.1-4.5-4.5-4.5h-243.9c-2.5,0-4.5,2.1-4.5,4.5v168.8h253V89.1Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M500.2,80h-243.9c-1.6,0-3.2.4-4.4,1.2l-43.5,11.4c-4,1-6.8,4.7-6.8,8.8v215.8h-18.3V125.8c0-4.5-3.2-8.1-7.1-8.1h-72.5c-3.9,0-7.1,3.7-7.1,8.1v356.5c0,4.5,3.2,8.1,7.1,8.1h97.8v20.5c0,5.1,4.1,9.1,9.1,9.1h289.6c5.1,0,9.1-4.1,9.1-9.1V89.1c0-5-4-9.1-9-9.1ZM178.7,482.2c0,2-1.2,3.6-2.6,3.6h-72.5c-1.4,0-2.6-1.6-2.6-3.5h0V125.8c0-2,1.2-3.6,2.6-3.6h72.5c1.4,0,2.6,1.7,2.6,3.6v356.5ZM251.7,89.1c0-2.5,2.1-4.5,4.5-4.5h243.9c2.5,0,4.5,2.1,4.5,4.5v168.8h-253V89.1ZM241.4,492.7h-10.3c-2.5,0-4.5-2-4.5-4.5V111.9c0-2.5,2-4.5,4.5-4.5h10.3c2.5,0,4.5,2,4.5,4.5v376.3c0,2.5-2,4.5-4.5,4.5ZM241.4,102.9h-10.3c-5.1,0-9.1,4.1-9.1,9.1v205.2h-16V101.3c0-2.1,1.4-3.9,3.4-4.4l37.8-9.9h0c-.1.6-.2,1.4-.2,2.1v15.7c-1.5-1.2-3.5-2-5.7-2ZM183.2,482.2h0v-160.5h0c0,0,38.7,0,38.7,0h0v164.1h-39.5c.4-1.1.7-2.3.7-3.6ZM248.3,515.5h-37.6c-2.5,0-4.5-2.1-4.5-4.5v-20.5h0s16.3,0,16.3,0c1,4,4.5,6.8,8.8,6.8h10.3c2.1,0,4-.7,5.6-1.9,0,0,0,0,.1-.1v15.7c0,1.7.4,3.2,1.2,4.5h-.1ZM504.8,511h0c0,2.5-2.1,4.5-4.5,4.5h-243.9c-2.5,0-4.5-2.1-4.5-4.5h0v-214.3h253.1v214.3ZM504.8,292h-253.1v-29.6h253.1v29.6Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 226.6,
    y: 107.4,
    width: 19.4,
    height: 385.4,
    rx: 4.5,
    ry: 4.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.4,281.8s0,0,0,0,0,0,0,0c2.5,0,4.5-2.1,4.5-4.5,0,0,0,0,0,0,0-2.5-2.1-4.5-4.5-4.5s-4.5,2.1-4.5,4.5,0,0,0,0c0,2.5,2,4.5,4.5,4.5Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M290.4,286.3c5.1,0,9.1-4.1,9.1-9.1s-4.1-9.1-9.1-9.1-9.1,4.1-9.1,9.1,4.1,9.1,9.1,9.1ZM285.9,277.2c0-2.5,2.1-4.5,4.5-4.5s4.5,2.1,4.5,4.5h0s0,0,0,0c0,2.5-2,4.5-4.5,4.5,0,0,0,0,0,0s0,0,0,0c-2.5,0-4.5-2.1-4.5-4.5,0,0,0,0,0,0h0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M378.2,281.8s0,0,0,0,0,0,0,0c2.5,0,4.5-2.1,4.5-4.5,0,0,0,0,0,0,0-2.5-2.1-4.5-4.5-4.5s-4.5,2.1-4.5,4.5,0,0,0,0c0,2.5,2,4.5,4.5,4.5Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M378.2,286.3c5.1,0,9.1-4.1,9.1-9.1s-4.1-9.1-9.1-9.1-9.1,4.1-9.1,9.1,4.1,9.1,9.1,9.1ZM373.7,277.2c0-2.5,2.1-4.5,4.5-4.5s4.5,2.1,4.5,4.5h0s0,0,0,0c0,2.5-2,4.5-4.5,4.5,0,0,0,0,0,0s0,0,0,0c-2.5,0-4.5-2.1-4.5-4.5,0,0,0,0,0,0h0Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M466,281.8s0,0,0,0,0,0,0,0c2.5,0,4.5-2.1,4.5-4.5,0,0,0,0,0,0,0-2.5-2.1-4.5-4.5-4.5s-4.5,2.1-4.5,4.5,0,0,0,0c0,2.5,2,4.5,4.5,4.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M466,286.3c5.1,0,9.1-4.1,9.1-9.1s-4.1-9.1-9.1-9.1-9.1,4.1-9.1,9.1,4.1,9.1,9.1,9.1ZM461.5,277.2c0-2.5,2.1-4.5,4.5-4.5s4.5,2.1,4.5,4.5h0s0,0,0,0c0,2.5-2,4.5-4.5,4.5,0,0,0,0,0,0s0,0,0,0c-2.5,0-4.5-2.1-4.5-4.5,0,0,0,0,0,0h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnace);
export default __webpack_public_path__ + "static/media/furnace.e34bae83884756325f0126e5373b667f.svg";
export { ForwardRef as ReactComponent };